module.exports = __webpack_public_path__ + "static/media/kaiser.8dce2e25.svg";